export class ContactObject {

    constructor(private name: string, private phone: string, private email: string) {

    }

    public static create() {
        return new ContactObject('', '', '');
    }
}
